/**
 * VIIMPII Build Your Own Bundle
 * Single global controller + document event delegation.
 */
(function () {
  'use strict';

  var activeCtrl = null;

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function toInt(val, fallback) {
    var n = parseInt(val, 10);
    return isNaN(n) ? (fallback || 0) : n;
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
  }

  function toCheckoutImageUrl(url) {
    if (!url) return '';
    var u = String(url).trim();
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;

    var shop = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : '';
    if (shop) {
      u = u.replace(/https?:\/\/127\.0\.0\.1(?::\d+)?/i, 'https://' + shop);
      u = u.replace(/https?:\/\/localhost(?::\d+)?/i, 'https://' + shop);
    }
    if (u.indexOf('http://') === 0) u = 'https://' + u.slice(7);

    var cdnIndex = u.indexOf('/cdn/shop/');
    if (cdnIndex !== -1 && shop) {
      u = 'https://' + shop + u.slice(cdnIndex);
    } else if (u.indexOf('/') === 0) {
      u = (shop ? ('https://' + shop) : (window.location.origin || '')) + u;
    }

    u = u.split('#')[0];
    var qIndex = u.indexOf('?');
    var path = qIndex === -1 ? u : u.slice(0, qIndex);
    var query = qIndex === -1 ? '' : u.slice(qIndex + 1);

    // Checkout only renders a property as an image when the path looks like
    // jpg/png/gif. Shopify CDN still serves JPEG if we append .jpg to .webp.
    if (/\.(webp|avif|heic)$/i.test(path) && !/\.(jpe?g|png|gif)$/i.test(path)) {
      path = path.replace(/\.(webp|avif|heic)$/i, '.$1.jpg');
    } else if (!/\.(jpe?g|png|gif)$/i.test(path)) {
      path += '.jpg';
    }

    var version = '';
    var versionMatch = query.match(/(?:^|&)v=([^&]*)/);
    if (versionMatch) version = versionMatch[1];

    var out = path + '?width=120&format=jpg';
    if (version) out += '&v=' + version;
    if (out.length > 255) {
      out = version ? (path + '?v=' + version) : path;
    }
    return out.slice(0, 255);
  }

  function generateBundleId() {
    var d = new Date();
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1);
    var day = String(d.getDate());
    if (m.length < 2) m = '0' + m;
    if (day.length < 2) day = '0' + day;
    return 'BYOB-' + y + m + day + '-' + Math.random().toString(36).slice(2, 8).toUpperCase();
  }

  function normalizeTier(tier) {
    return {
      pieceCount: toInt(tier && tier.pieceCount, 3),
      label: (tier && tier.label) || '',
      bundleVariantId: tier && tier.bundleVariantId ? toInt(tier.bundleVariantId, 0) : null,
      bundlePrice: toInt(tier && tier.bundlePrice, 0),
      tierPriceRupees: toInt(tier && tier.tierPriceRupees, 0),
      priceLabel: (tier && tier.priceLabel) || '—'
    };
  }

  function parseConfig(root) {
    var el = qs('[data-byob-config]', root);
    if (!el) el = qs('[data-byob-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      console.error('[BYOB] Config parse error', err);
      return null;
    }
  }

  function readTiersFromDOM(root) {
    return qsa('.viimpii-byob__tier[data-byob-tier]', root).map(function (btn) {
      return normalizeTier({
        pieceCount: btn.getAttribute('data-piece-count'),
        label: btn.getAttribute('data-tier-label'),
        bundleVariantId: btn.getAttribute('data-bundle-variant-id'),
        bundlePrice: btn.getAttribute('data-bundle-price'),
        tierPriceRupees: btn.getAttribute('data-tier-price-rupees'),
        priceLabel: btn.getAttribute('data-price-label')
      });
    });
  }

  function mergeTiers(configTiers, domTiers) {
    var source = domTiers.length ? domTiers : (configTiers || []).map(normalizeTier);
    return source.map(function (tier, i) {
      var cfg = normalizeTier((configTiers || [])[i] || {});
      return normalizeTier({
        pieceCount: tier.pieceCount || cfg.pieceCount,
        label: tier.label || cfg.label,
        bundleVariantId: tier.bundleVariantId || cfg.bundleVariantId,
        bundlePrice: tier.bundlePrice || cfg.bundlePrice,
        tierPriceRupees: tier.tierPriceRupees || cfg.tierPriceRupees,
        priceLabel: tier.priceLabel || cfg.priceLabel
      });
    });
  }

  function findCardByVariant(root, variantId) {
    var cards = qsa('[data-byob-card]', root);
    for (var i = 0; i < cards.length; i++) {
      if (readCard(cards[i]).variantId === String(variantId)) return cards[i];
    }
    return null;
  }

  function moneyToRupees(raw) {
    var n = toInt(raw, 0);
    // Shopify Liquid variant.price is in cents (paisa).
    if (n >= 1000) return Math.round(n / 100);
    return n;
  }

  /** "₹1,049.00" / "Rs. 1,049" → 1049 (never treat paise as extra digits). */
  function parseMoneyLabel(label) {
    var cleaned = String(label || '').replace(/[^\d.]/g, '');
    if (!cleaned) return 0;
    var whole = cleaned.split('.')[0] || '0';
    var n = parseInt(whole, 10);
    return isNaN(n) ? 0 : n;
  }

  function resolveTierPriceRupees(tier) {
    if (tier && tier.tierPriceRupees > 0) return toInt(tier.tierPriceRupees, 0);
    // Bundle SKU price from Liquid is always cents — most reliable.
    var fromSku = moneyToRupees(tier && tier.bundlePrice);
    if (fromSku > 0) return fromSku;
    return parseMoneyLabel(tier && tier.priceLabel);
  }

  function readCard(card) {
    var select = qs('[data-byob-variant-select]', card);
    var variantId = card.getAttribute('data-default-variant-id') || card.getAttribute('data-variant-id') || '';
    var price = moneyToRupees(card.getAttribute('data-price'));
    var priceLabel = '';
    var sku = '';
    var available = card.getAttribute('data-available') === 'true';
    var image = card.getAttribute('data-image') || '';

    if (select) {
      var opt = select.options[select.selectedIndex];
      if (opt) {
        variantId = opt.value;
        price = moneyToRupees(opt.getAttribute('data-price'));
        priceLabel = opt.getAttribute('data-price-label') || '';
        sku = opt.getAttribute('data-sku') || '';
        available = opt.getAttribute('data-available') === 'true';
      }
    }

    return {
      variantId: String(variantId || ''),
      productId: card.getAttribute('data-product-id') || '',
      title: card.getAttribute('data-shade-name') || '',
      handle: card.getAttribute('data-product-handle') || '',
      image: image,
      price: price,
      priceLabel: priceLabel,
      sku: sku,
      available: available
    };
  }

  function cartHasDiscountCode(cart, code) {
    if (!cart || !code) return false;
    var upper = String(code).toUpperCase();
    var codes = cart.discount_codes || [];
    if (codes.some(function (d) {
      return String(d.code || '').toUpperCase() === upper;
    })) return true;
    var apps = cart.cart_level_discount_applications || [];
    if (apps.some(function (a) {
      return String(a.title || a.code || '').toUpperCase() === upper;
    })) return true;
    // Line-level product discounts (shown under each cart item title)
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var allocs = items[i].line_level_discount_allocations || [];
      for (var j = 0; j < allocs.length; j++) {
        var title = allocs[j].discount_application && allocs[j].discount_application.title;
        if (String(title || '').toUpperCase() === upper) return true;
      }
    }
    return false;
  }

  function rememberByobDiscount(code, pieceCount) {
    if (!code) return;
    try {
      sessionStorage.setItem('viimpii_byob_discount', code);
      if (pieceCount) sessionStorage.setItem('viimpii_byob_size', String(pieceCount));
    } catch (e) {}
  }

  function readRememberedByobDiscount() {
    try { return sessionStorage.getItem('viimpii_byob_discount') || ''; } catch (e) { return ''; }
  }

  function getByobDiscountFromCart(cart) {
    if (!cart) return readRememberedByobDiscount();
    var attrs = cart.attributes || {};
    var fromAttr = attrs.byob_discount_code || attrs._byob_discount_code || '';
    if (fromAttr) return String(fromAttr);
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      var c = String(codes[i].code || '');
      if (c.toUpperCase().indexOf('BYOB') === 0) return c;
    }
    var items = cart.items || [];
    for (var k = 0; k < items.length; k++) {
      var allocs = items[k].line_level_discount_allocations || [];
      for (var n = 0; n < allocs.length; n++) {
        var t = allocs[n].discount_application && allocs[n].discount_application.title;
        if (t && String(t).toUpperCase().indexOf('BYOB') === 0) return String(t);
      }
      var props = items[k].properties || {};
      if (props['_BYOB Discount']) return String(props['_BYOB Discount']);
    }
    return readRememberedByobDiscount();
  }

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function clearAllCartDiscounts() {
    try {
      sessionStorage.removeItem('viimpii_byob_discount');
      sessionStorage.removeItem('viimpii_byob_size');
      sessionStorage.removeItem('viimpii_combo_discount');
    } catch (e) {}
    var sectionIds = getCartSectionIds();
    var body = {
      discount: '',
      attributes: {
        byob_discount_code: '',
        _byob_discount_code: '',
        combo_discount_code: ''
      }
    };
    if (sectionIds.length) body.sections = sectionIds.join(',');
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.ok ? r.json().catch(function () { return null; }) : null;
      })
      .catch(function () {
        return null;
      });
  }

  function applyByobDiscountCode(code, pieceCount) {
    if (!code) return Promise.resolve(false);
    rememberByobDiscount(code, pieceCount);
    var sectionIds = getCartSectionIds();
    var body = {
      discount: code,
      attributes: {
        byob_discount_code: code,
        combo_discount_code: ''
      }
    };
    if (sectionIds.length) body.sections = sectionIds.join(',');
    // Apply code + store on cart attributes so checkout can re-attach it.
    // Never use /discount/:code — theme preview returns 401.
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) return false;
        return r.json().catch(function () { return null; });
      })
      .then(function (cart) {
        if (cartHasDiscountCode(cart, code)) return cart || true;
        return fetchCart().then(function (fresh) {
          if (cartHasDiscountCode(fresh, code)) return fresh;
          return fetch(cartRoot() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify(body)
          })
            .then(function (r2) { return r2.ok ? r2.json() : null; })
            .then(function (c2) { return cartHasDiscountCode(c2, code) ? c2 : false; });
        });
      })
      .catch(function () { return false; });
  }

  function checkoutWithByobDiscount(code) {
    var url = cartRoot() + 'checkout';
    if (code) {
      url += (url.indexOf('?') >= 0 ? '&' : '?') + 'discount=' + encodeURIComponent(code);
    }
    window.location.href = url;
  }

  /** Cart shows BYOB price but Checkout often drops the code — force it on the URL. */
  function initByobCheckoutBridge() {
    if (window.__viimpiiByobCheckoutBridge) return;
    window.__viimpiiByobCheckoutBridge = true;

    function cartLooksLikeByob(cart) {
      // Exact piece count only — 3 means 3, not 2 or 4
      var groups = {};
      (cart.items || []).forEach(function (item) {
        var props = item.properties || {};
        var handle = String(item.handle || '').toLowerCase();
        if (handle.indexOf('byob-') === 0) {
          groups[item.key] = { required: 1, qty: item.quantity || 1 };
          return;
        }
        if (!(props['_BYOB Discount'] || props['_BYOB'] || props['Box Size'] || props['_Bundle Size'])) {
          var bundleId = String(props['_Bundle ID'] || '').toLowerCase();
          if (bundleId.indexOf('byob') !== 0) return;
        }
        var id = String(props['_Bundle ID'] || '__byob__');
        if (!groups[id]) groups[id] = { required: 0, qty: 0 };
        groups[id].qty += item.quantity || 1;
        var req = parseInt(props['_Bundle Size'] || props['Box Size'] || '0', 10);
        if (!req) {
          var m = String(props['_BYOB'] || '').match(/(\d+)\s*for/i);
          if (m) req = parseInt(m[1], 10) || 0;
        }
        if (!req) {
          var m2 = String(props['_BYOB Discount'] || '').match(/^BYOB(\d+)OFF/i);
          if (m2) req = parseInt(m2[1], 10) || 0;
        }
        if (req > groups[id].required) groups[id].required = req;
      });
      return Object.keys(groups).some(function (id) {
        var g = groups[id];
        return g.required > 0 && g.qty === g.required;
      });
    }

    function handleCheckoutIntent(e) {
      var el = e.target && e.target.closest
        ? e.target.closest('#checkout, [name="checkout"], .cart__checkout-button, a[href*="/checkout"]')
        : null;
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      fetchCart()
        .then(function (cart) {
          if (!cartLooksLikeByob(cart)) {
            // Don't force a leftover BYOB code onto combo / normal carts
            try { sessionStorage.removeItem('viimpii_byob_discount'); } catch (err) {}
            window.location.href = cartRoot() + 'checkout';
            return;
          }
          var code = getByobDiscountFromCart(cart);
          checkoutWithByobDiscount(code);
        })
        .catch(function () {
          window.location.href = cartRoot() + 'checkout';
        });
    }

    document.addEventListener('click', handleCheckoutIntent, true);
  }

  function removeCartLinesByBundleId(bundleId) {
    if (!bundleId) return Promise.resolve();
    return fetchCart().then(function (cart) {
      var updates = {};
      (cart.items || []).forEach(function (item) {
        var props = item.properties || {};
        if (String(props['_Bundle ID'] || '') === String(bundleId)) {
          updates[item.key] = 0;
        }
      });
      if (!Object.keys(updates).length) return cart;
      return fetch(cartRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { return r.json(); });
    });
  }

  function addBundleSkuLine(tier, items, props) {
    var slot = 1;
    var lineProps = Object.assign({}, props);
    items.forEach(function (item) {
      var qty = Math.max(1, toInt(item.quantity, 1));
      var img = toCheckoutImageUrl(item.image);
      var title = item.title || ('Shade ' + slot);
      var q;
      for (q = 0; q < qty; q++) {
        if (img) lineProps[String(slot) + '. ' + title] = img;
        else lineProps['Shade ' + slot] = title;
        slot += 1;
      }
    });
    return postAddToCart({ id: tier.bundleVariantId, quantity: 1, properties: lineProps });
  }

  function fetchCart() {
    return fetch(cartRoot() + 'cart.js').then(function (r) { return r.json(); });
  }

  function postAddToCart(payload) {
    var sectionIds = getCartSectionIds();
    var body = payload;
    if (sectionIds.length) {
      body = Object.assign({}, payload, { sections: sectionIds.join(',') });
    }
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  function dispatchCartUpdate(cart, variantId, sections) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        data: {
          itemCount: cart && cart.item_count,
          variantId: String(variantId || ''),
          source: 'viimpii-byob',
          sections: sections || undefined
        }
      }
    }));
  }

  function openThemeCartDrawer() {
    var trigger = qs('[data-testid="cart-drawer-trigger"]');
    if (trigger) { trigger.click(); return true; }
    return false;
  }

  function openCartAfterByob(cart, sections) {
    // Pause price-guard so it doesn't clear a fresh complete BYOB
    window.__viimpiiPauseCartGuardUntil = Date.now() + 3000;
    // Clear leftover virtual line-bundle UI so it doesn't replace the real cart
    try { sessionStorage.removeItem('viimpii_bundle_cart'); } catch (e) {}

    if (typeof window.setCartPriceLoading === 'function') {
      window.setCartPriceLoading(true);
    } else {
      document.dispatchEvent(new CustomEvent('viimpii:cart-price-loading', { detail: { on: true } }));
    }

    dispatchCartUpdate(cart, '', sections);

    setTimeout(function () {
      if (typeof window.setCartPriceLoading === 'function') {
        window.setCartPriceLoading(false);
      } else {
        document.dispatchEvent(new CustomEvent('viimpii:cart-price-loading', { detail: { on: false } }));
      }
    }, 900);

    // auto-open on cart-drawer already opens from cart:update — don't click again
    var drawer = document.querySelector('cart-drawer-component[auto-open]');
    if (drawer) return true;
    return openThemeCartDrawer();
  }

  function createController(root, config) {
    var tiers = mergeTiers(config.tiers || [], readTiersFromDOM(root));
    if (!tiers.length) {
      console.error('[BYOB] No tiers found');
      return null;
    }

    var cartMode = root.getAttribute('data-cart-mode') || config.cartMode || 'components';
    var redirectToCheckout = config.redirectToCheckout === true;

    var state = {
      tierIndex: 0,
      items: {},
      isSubmitting: false
    };

    function activeTier() {
      return tiers[state.tierIndex] || tiers[0];
    }

    function bundleSize() {
      return toInt(activeTier().pieceCount, toInt(config.defaultPieceCount, 3));
    }

    function bundlePrice() {
      return toInt(activeTier().bundlePrice, 0);
    }

    function totalSelected() {
      var sum = 0;
      Object.keys(state.items).forEach(function (k) {
        sum += toInt(state.items[k].quantity, 0);
      });
      return sum;
    }

    function remainingSelected() {
      return Math.max(bundleSize() - totalSelected(), 0);
    }

    function isComplete() {
      return bundleSize() > 0 && totalSelected() === bundleSize();
    }

    function syncGlobalState() {
      var tier = activeTier();
      window.byobState = {
        bundleSize: bundleSize(),
        bundlePrice: bundlePrice(),
        bundlePriceLabel: tier.priceLabel,
        bundleVariantId: tier.bundleVariantId,
        tierIndex: state.tierIndex,
        selectedCount: totalSelected(),
        remainingCount: remainingSelected(),
        isComplete: isComplete(),
        isSubmitting: state.isSubmitting,
        items: getItemsArray()
      };
    }

    function getItemsArray() {
      return Object.keys(state.items).map(function (k) { return state.items[k]; })
        .filter(function (item) { return item && toInt(item.quantity, 0) > 0; });
    }

    function showToast(msg) {
      var toast = qs('[data-byob-toast]', root);
      if (!toast) return;
      toast.textContent = msg;
      toast.hidden = false;
      clearTimeout(showToast._t);
      showToast._t = setTimeout(function () { toast.hidden = true; }, 3500);
    }

    function persistState() {
      try {
        localStorage.setItem(config.storageKey || 'viimpii_byob_state', JSON.stringify({
          tierIndex: state.tierIndex,
          items: state.items
        }));
      } catch (e) {}
    }

    function restoreState() {
      try {
        var raw = localStorage.getItem(config.storageKey || 'viimpii_byob_state');
        if (!raw) return;
        var saved = JSON.parse(raw);
        if (saved && typeof saved.tierIndex === 'number' && saved.tierIndex < tiers.length) {
          state.tierIndex = saved.tierIndex;
        }
        if (saved && saved.items) {
          state.items = saved.items;
          Object.keys(state.items).forEach(function (vid) {
            var item = state.items[vid];
            if (item && item.qty && !item.quantity) item.quantity = item.qty;
            // Prevent duplicates: allow each variant only once in the BYOB poster.
            if (item && item.quantity && toInt(item.quantity, 0) > 1) item.quantity = 1;
            if (item && item.qty) delete item.qty;
          });
        }
        trimToSize(true);
      } catch (e) {}
    }

    function clearPersistedState() {
      try { localStorage.removeItem(config.storageKey || 'viimpii_byob_state'); } catch (e) {}
    }

    function trimToSize(silent) {
      while (totalSelected() > bundleSize()) {
        var keys = Object.keys(state.items);
        if (!keys.length) break;
        var key = keys[keys.length - 1];
        if (state.items[key].quantity > 1) state.items[key].quantity -= 1;
        else delete state.items[key];
      }
      if (!silent && totalSelected() > bundleSize() && config.tierChangeMessage) {
        showToast(config.tierChangeMessage);
      }
    }

    function findItemKeyByProductId(productId) {
      if (!productId) return null;
      var keys = Object.keys(state.items);
      for (var i = 0; i < keys.length; i++) {
        if (String(state.items[keys[i]].productId) === String(productId)) return keys[i];
      }
      return null;
    }

    function setQuantity(variantId, qty, card) {
      if (!card) card = findCardByVariant(root, variantId);
      if (!card) return;

      var data = readCard(card);
      if (!data.variantId) {
        console.warn('[BYOB] Missing variant ID', data);
        return;
      }
      if (qty > 0 && !data.available) return;

      qty = Math.max(0, toInt(qty, 0));
      // One shade = one slot only (no duplicates).
      if (qty > 1) qty = 1;
      var current = state.items[variantId] ? toInt(state.items[variantId].quantity, 0) : 0;
      var delta = qty - current;

      if (delta > 0 && totalSelected() + delta > bundleSize()) {
        if (remainingSelected() === 0) {
          showToast('Your bundle is full. Remove an item or choose a larger bundle.');
          return;
        }
        qty = current + remainingSelected();
        if (qty > 1) qty = 1;
      }

      if (qty <= 0) {
        delete state.items[variantId];
      } else {
        state.items[variantId] = {
          productId: data.productId,
          variantId: data.variantId,
          title: data.title,
          handle: data.handle,
          quantity: 1,
          price: data.price,
          priceLabel: data.priceLabel,
          sku: data.sku,
          image: data.image,
          available: data.available
        };
      }

      console.log('[BYOB] Total Selected:', totalSelected());
      renderAll();
    }

    function addProduct(card) {
      if (!card) {
        console.warn('[BYOB] No product card found for add');
        return;
      }
      var data = readCard(card);
      console.log('[BYOB] Product Added', data.title, 'Variant ID:', data.variantId);

      if (!data.available || !data.variantId) {
        showToast('This product is unavailable.');
        return;
      }

      var existingKey = findItemKeyByProductId(data.productId) ||
        (state.items[data.variantId] ? data.variantId : null);
      if (existingKey) {
        showToast('This shade is already in your box. Pick a different one.');
        return;
      }

      if (remainingSelected() === 0) {
        showToast('Your bundle is full. Remove an item or choose a larger bundle.');
        return;
      }

      setQuantity(data.variantId, 1, card);
    }

    function removeProduct(card) {
      if (!card) return;
      var data = readCard(card);
      var key = findItemKeyByProductId(data.productId) || data.variantId;
      if (!key || !state.items[key]) return;
      setQuantity(key, 0, card);
    }

    function selectTier(index, scrollAfter) {
      if (index < 0 || index >= tiers.length) return;
      if (index === state.tierIndex && !scrollAfter) return;

      var newSize = toInt(tiers[index].pieceCount, 3);
      var changing = index !== state.tierIndex;

      if (changing && totalSelected() > newSize) {
        var msg = config.tierChangeConfirm ||
          'Changing the bundle size may remove some selected quantities. Continue?';
        if (!window.confirm(msg)) return;
      }

      state.tierIndex = index;
      trimToSize(true);
      console.log('[BYOB] Bundle Selected:', newSize, tiers[index].priceLabel);
      renderAll();

      if (changing) showToast(newSize + ' pieces · ' + (tiers[index].priceLabel || ''));
      if (scrollAfter) {
        var el = qs('#viimpii-byob-tiers', root) || qs('[data-byob-grid]', root);
        if (el) {
          var top = el.getBoundingClientRect().top + window.pageYOffset - 88;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }
      }
    }

    function validateBundle() {
      var size = bundleSize();
      var total = totalSelected();
      if (total < size) {
        return { ok: false, message: (config.pickMoreTemplate || 'Please select __COUNT__ more products.')
          .replace('__COUNT__', String(size - total)) };
      }
      if (total > size) return { ok: false, message: 'Too many items selected.' };

      var items = getItemsArray();
      if (!items.length) return { ok: false, message: 'Your bundle is empty.' };

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var card = findCardByVariant(root, item.variantId);
        var live = card ? readCard(card) : item;
        if (!live.variantId || live.variantId === 'undefined') {
          return { ok: false, message: 'Invalid variant for ' + (live.title || 'product') + '.' };
        }
        if (!live.available) {
          return { ok: false, message: (live.title || 'Product') + ' is out of stock.' };
        }
      }

      if (cartMode === 'bundle_sku' && !activeTier().bundleVariantId) {
        return { ok: false, message: 'Bundle product not linked for this tier.' };
      }
      return { ok: true };
    }

    function addBundleToCart() {
      if (state.isSubmitting) return;

      var check = validateBundle();
      console.log('[BYOB] Bundle validation:', check);
      if (!check.ok) { showToast(check.message); return; }

      var tier = activeTier();
      var bundleId = generateBundleId();
      state.isSubmitting = true;
      renderAll();

      var items = getItemsArray();
      var retailRupees = 0;
      items.forEach(function (item) {
        var card = findCardByVariant(root, item.variantId);
        var live = card ? readCard(card) : item;
        var unit = toInt(live.price, 0) || moneyToRupees(item.price);
        retailRupees += unit * Math.max(1, toInt(item.quantity, 1));
      });

      // Same idea as Combo Edit: cart total must equal the advertised tier price.
      var knownTier = { 3: 1049, 4: 1349, 6: 1949, 8: 2499 };
      var pieceCount = toInt(tier.pieceCount, 3);
      var tierPrice = resolveTierPriceRupees(tier) || knownTier[pieceCount] || 0;
      // Prefer advertised label price when SKU price drifts
      var fromLabel = parseMoneyLabel(tier.priceLabel);
      if (knownTier[pieceCount] && fromLabel === knownTier[pieceCount]) {
        tierPrice = fromLabel;
      } else if (knownTier[pieceCount] && Math.abs((tierPrice || 0) - knownTier[pieceCount]) > 5) {
        tierPrice = knownTier[pieceCount];
      }
      var discountOff = Math.max(0, retailRupees - tierPrice);
      var discountCode = discountOff > 0
        ? ('BYOB' + pieceCount + 'OFF' + discountOff)
        : '';

      var props = {
        '_Bundle Type': config.bundleTypeLabel || 'Build Your Own Bundle',
        '_Bundle Size': String(pieceCount),
        '_Bundle ID': bundleId,
        '_Bundle Price': '₹' + tierPrice
      };

      console.log('[BYOB] Adding shades to cart...', {
        bundleId: bundleId,
        tier: pieceCount,
        retailRupees: retailRupees,
        tierPrice: tierPrice,
        discountCode: discountCode
      });

      // Always wipe old BYOB3/Combo codes before applying this tier's code (fixes 4→₹1050 bug)
      var promise = clearAllCartDiscounts().then(function () {
        if (cartMode === 'bundle_sku' && tier.bundleVariantId) {
          return addBundleSkuLine(tier, items, props);
        }
        return postAddToCart({
          items: items.map(function (item) {
            return {
              id: toInt(item.variantId, 0),
              quantity: toInt(item.quantity, 1),
              properties: {
                '_Bundle ID': bundleId,
                '_Bundle Size': String(pieceCount),
                '_BYOB': String(pieceCount) + ' for ₹' + tierPrice,
                '_BYOB Discount': discountCode || '',
                Bundle: String(pieceCount) + ' for ₹' + tierPrice
              }
            };
          })
        }).then(function (result) {
          if (!discountCode) return result;
          return applyByobDiscountCode(discountCode, pieceCount).then(function (discountCart) {
            if (discountCart && discountCart.sections) {
              result = result || {};
              result.sections = discountCart.sections;
            }
            return result;
          });
        });
      });

      promise
        .then(function (addResult) {
          return fetchCart().then(function (cart) {
            return { cart: cart, sections: addResult && addResult.sections };
          });
        })
        .then(function (payload) {
          var cart = payload.cart;
          console.log('[BYOB] Cart response OK', {
            items: cart.item_count,
            total: cart.total_price,
            codes: cart.discount_codes,
            expectedRupees: tierPrice
          });

          state.items = {};
          clearPersistedState();
          state.isSubmitting = false;
          renderAll();
          showToast(config.addedMessage || 'Bundle Added ✓');
          if (redirectToCheckout) {
            checkoutWithByobDiscount(discountCode || getByobDiscountFromCart(cart));
          } else if (!openCartAfterByob(cart, payload.sections)) {
            window.location.href = cartRoot() + 'cart';
          }
        })
        .catch(function (err) {
          console.error('[BYOB] Cart error', err);
          showToast((err && (err.description || err.message)) || 'Unable to add bundle to cart.');
          state.isSubmitting = false;
          renderAll();
        });
    }

    function renderTierButtons() {
      qsa('[data-byob-tier]', root).forEach(function (btn) {
        var idx = toInt(btn.getAttribute('data-tier-index'), -1);
        var on = idx === state.tierIndex;
        btn.classList.toggle('is-active', on);
        if (btn.getAttribute('role') === 'tab') btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function renderProgress() {
      var total = totalSelected();
      var size = bundleSize();
      var pct = size > 0 ? Math.min(100, Math.max(0, (total / size) * 100)) : 0;

      qsa('[data-byob-progress-count]', root).forEach(function (el) { el.textContent = String(total); });
      qsa('[data-byob-piece-target]', root).forEach(function (el) { el.textContent = String(size); });
      qsa('[data-byob-remaining]', root).forEach(function (el) { el.textContent = String(remainingSelected()); });

      var prog = qs('[data-byob-tier-progress]', root);
      if (prog) prog.classList.toggle('is-complete', isComplete());

      var fill = qs('[data-byob-bar-progress-fill]', root);
      if (fill) fill.style.width = pct + '%';
    }

    function renderSummary() {
      var tier = activeTier();
      var total = totalSelected();
      var size = bundleSize();
      var rem = remainingSelected();
      var done = isComplete();

      var retail = 0;
      getItemsArray().forEach(function (item) {
        var card = findCardByVariant(root, item.variantId);
        var live = card ? readCard(card) : item;
        var unit = toInt(live.price, 0) || moneyToRupees(item.price);
        retail += unit * Math.max(1, toInt(item.quantity, 1));
      });
      var displayPrice = done
        ? (tier.priceLabel || ('₹' + resolveTierPriceRupees(tier).toLocaleString('en-IN')))
        : (total > 0
          ? ('₹' + Math.round(retail).toLocaleString('en-IN'))
          : '₹0');

      qsa('[data-byob-total], [data-byob-total-mobile]', root).forEach(function (el) {
        el.textContent = displayPrice;
        el.classList.toggle('is-bundle-price', done);
        el.classList.toggle('is-retail-price', !done && total > 0);
      });

      var status = qs('[data-byob-bar-status]', root);
      if (status) {
        if (state.isSubmitting) {
          status.textContent = config.addingMessage || 'Updating price…';
        } else if (done) {
          status.textContent = '✓ ' + (config.completeBarTemplate || 'Your __COUNT__-piece bundle is complete!')
            .replace('__COUNT__', String(size));
        } else if (rem > 0) {
          status.textContent = (config.pickMoreTemplate || 'Select __COUNT__ more products to complete your bundle')
            .replace('__COUNT__', String(rem));
        } else {
          status.textContent = config.incompleteMessage || '';
        }
      }

      var ready = qs('[data-byob-bar-ready]', root);
      if (ready) ready.hidden = !done;
      var bar = qs('[data-byob-bar]', root);
      if (bar) {
        bar.classList.toggle('is-complete', done);
        bar.classList.toggle('is-updating', !!state.isSubmitting);
      }

      var thumbs = qs('[data-byob-bar-thumbs]', root);
      if (thumbs) {
        var slots = [];
        getItemsArray().forEach(function (item) {
          for (var i = 0; i < item.quantity; i++) slots.push(item);
        });
        var html = '';
        for (var s = 0; s < size; s++) {
          var slot = slots[s];
          html += slot && slot.image
            ? '<span class="viimpii-byob__bar-thumb"><img src="' + slot.image + '" alt="" width="48" height="48"></span>'
            : '<span class="viimpii-byob__bar-thumb viimpii-byob__bar-thumb--empty"></span>';
        }
        thumbs.innerHTML = html;
      }

      qsa('[data-byob-checkout]', root).forEach(function (btn) {
        var needSku = cartMode === 'bundle_sku' && !tier.bundleVariantId;
        btn.disabled = !done || state.isSubmitting || needSku;
        btn.classList.toggle('is-ready', done && !state.isSubmitting);
        var lbl = qs('[data-byob-checkout-label]', btn) || btn;
        if (state.isSubmitting) lbl.textContent = config.addingMessage || 'Adding Bundle...';
        else if (done) lbl.textContent = config.checkoutLabel || 'ADD BUNDLE TO CART';
        else lbl.textContent = config.incompleteCheckoutLabel || 'Complete Your Bundle';
      });
    }

    function renderProducts() {
      var rem = remainingSelected();

      qsa('[data-byob-card]', root).forEach(function (card) {
        var data = readCard(card);
        var existingKey = findItemKeyByProductId(data.productId) ||
          (state.items[data.variantId] ? data.variantId : null);
        var qty = existingKey && state.items[existingKey]
          ? toInt(state.items[existingKey].quantity, 0)
          : 0;
        var inBox = qty > 0;
        var full = rem === 0 && !inBox;

        var addBtn = qs('[data-byob-add], .byob-add-btn', card);
        var qtyWrap = qs('[data-byob-qty-wrap]', card);
        var qtyVal = qs('[data-byob-qty-val]', card);
        var badge = qs('[data-byob-added-badge]', card);
        var addLabel = qs('[data-byob-add-label]', card);
        var plus = qs('[data-byob-qty-plus], .qty-plus', card);
        var minus = qs('[data-byob-qty-minus], .qty-minus', card);

        card.classList.toggle('is-in-box', inBox);
        card.classList.toggle('is-at-capacity', full);

        if (!data.available) {
          if (addBtn) addBtn.hidden = true;
          if (qtyWrap) qtyWrap.hidden = true;
          return;
        }

        // No quantity stepper — each shade can be picked only once.
        if (qtyWrap) {
          qtyWrap.hidden = true;
          qtyWrap.classList.add('is-hidden');
        }
        if (plus) plus.disabled = true;
        if (minus) minus.disabled = true;
        if (qtyVal) qtyVal.textContent = inBox ? '1' : '0';

        if (inBox) {
          if (addBtn) {
            addBtn.hidden = false;
            addBtn.disabled = false;
            addBtn.setAttribute('data-byob-action', 'remove');
          }
          if (badge) badge.hidden = false;
          if (addLabel) addLabel.textContent = config.removeLabel || 'Remove';
        } else {
          if (addBtn) {
            addBtn.hidden = false;
            addBtn.disabled = full;
            addBtn.setAttribute('data-byob-action', 'add');
          }
          if (badge) badge.hidden = true;
          if (addLabel) addLabel.textContent = config.addLabel || 'Add to Box';
        }
      });
    }

    function renderAll() {
      renderTierButtons();
      renderProgress();
      renderSummary();
      renderProducts();
      persistState();
      syncGlobalState();
    }

    function handleClick(e) {
      if (!root.contains(e.target)) return;

      var tierBtn = e.target.closest('[data-byob-tier], .bundle-option');
      if (tierBtn) {
        e.preventDefault();
        selectTier(toInt(tierBtn.getAttribute('data-tier-index'), 0),
          tierBtn.classList.contains('viimpii-byob__hero-tier'));
        return;
      }

      var filterBtn = e.target.closest('[data-byob-filter]');
      if (filterBtn) {
        e.preventDefault();
        var f = filterBtn.getAttribute('data-byob-filter') || 'all';
        qsa('[data-byob-filter]', root).forEach(function (b) { b.classList.toggle('is-active', b === filterBtn); });
        qsa('[data-byob-card]', root).forEach(function (card) {
          card.hidden = f !== 'all' && card.getAttribute('data-line') !== f;
        });
        return;
      }

      var addBtn = e.target.closest('[data-byob-add], .byob-add-btn');
      if (addBtn) {
        e.preventDefault();
        var cardAdd = addBtn.closest('[data-byob-card]');
        if (addBtn.getAttribute('data-byob-action') === 'remove') removeProduct(cardAdd);
        else addProduct(cardAdd);
        return;
      }

      var minusBtn = e.target.closest('[data-byob-qty-minus], .qty-minus');
      if (minusBtn) {
        e.preventDefault();
        removeProduct(minusBtn.closest('[data-byob-card]'));
        return;
      }

      var plusBtn = e.target.closest('[data-byob-qty-plus], .qty-plus');
      if (plusBtn) {
        e.preventDefault();
        showToast('This shade is already in your box. Pick a different one.');
        return;
      }

      if (e.target.closest('[data-byob-checkout]')) {
        e.preventDefault();
        addBundleToCart();
      }
    }

    function handleChange(e) {
      if (!root.contains(e.target)) return;
      var select = e.target.closest('[data-byob-variant-select]');
      if (!select) return;

      var card = select.closest('[data-byob-card]');
      var pid = card.getAttribute('data-product-id');
      var oldVid = null;
      Object.keys(state.items).forEach(function (vid) {
        if (state.items[vid].productId === pid) oldVid = vid;
      });

      if (oldVid) {
        var qty = toInt(state.items[oldVid].quantity, 0);
        delete state.items[oldVid];
        var data = readCard(card);
        if (qty > 0 && data.available && data.variantId) {
          state.items[data.variantId] = Object.assign({}, state.items[data.variantId] || {}, data, { quantity: qty });
        }
      }
      renderAll();
    }

    restoreState();

    try {
      var piecesParam = new URLSearchParams(window.location.search).get('pieces');
      if (piecesParam) {
        var wantPieces = toInt(piecesParam, 0);
        for (var ti = 0; ti < tiers.length; ti++) {
          if (toInt(tiers[ti].pieceCount, 0) === wantPieces) {
            state.tierIndex = ti;
            break;
          }
        }
      }
    } catch (e) {}

    renderAll();
    console.log('[BYOB] initialized');

    return {
      root: root,
      handleClick: handleClick,
      handleChange: handleChange,
      renderAll: renderAll
    };
  }

  function initByob() {
    var root = qs('[data-viimpii-byob]');
    if (!root) return;

    var config = parseConfig(root);
    if (!config) {
      console.error('[BYOB] Missing config');
      return;
    }

    activeCtrl = createController(root, config);
    if (!activeCtrl) {
      console.error('[BYOB] Controller failed to start');
      return;
    }
    window.ViimpiiByob = window.ViimpiiByob || {};
    window.ViimpiiByob.init = initByob;
    window.ViimpiiByob.controller = activeCtrl;
  }

  if (!window.__byobEventsBound) {
    window.__byobEventsBound = true;
    document.addEventListener('click', function (e) {
      if (activeCtrl) activeCtrl.handleClick(e);
    }, true);
    document.addEventListener('change', function (e) {
      if (activeCtrl) activeCtrl.handleChange(e);
    }, true);
  }

  function boot() {
    initByob();
    initByobCheckoutBridge();
  }

  // Checkout bridge must run on every page (cart drawer checkout lives in header).
  initByobCheckoutBridge();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-viimpii-byob]')) {
      boot();
    }
  });
})();
